import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteParamsService } from '@app/services/route-params.service';
import { CategoryListService } from '../category-deals-list.service';
import {
    CurrencyLanguageService,
    LocaleData,
} from '@app/shared/currency-language.service';
import { combineLatest, Subscription } from 'rxjs';
import { CategoryProducts } from '../model/category-products.model';
import { ProductCardEntry } from '@app/controls/product-card/product-card.model';
import { gtmDealClick } from '@app/utilities/ga.utils';
import { DeviceCommsService } from '@app/services/device-comms.service';

@Component({
    selector: 'md-category-all-deals',
    templateUrl: './category-all-deals.component.html',
    styleUrls: ['../category-deals-list.component.scss'],
})
export class CategoryAllDealsComponent implements OnInit, OnDestroy {
    sectionId: number;
    sectionName: string;
    localeData: LocaleData;
    categoryData: ProductCardEntry[] = [];
    totalRecords: number = 0;
    loadingMoreDeals = false;
    scrollablePane: Element;

    private paramsSubscription: Subscription;
    private subscription: Subscription;
    private categoryDealsSubscription: Subscription;
    private moreCategoryDealsSubscription: Subscription;

    private currentPage = 1;

    constructor(
        private activatedRoute: ActivatedRoute,
        private routeParamsService: RouteParamsService,
        private categoryService: CategoryListService,
        private currencyLanguageService: CurrencyLanguageService,
        private deviceCommsService: DeviceCommsService
    ) {}
    ngOnDestroy(): void {
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.categoryDealsSubscription) {
            this.categoryDealsSubscription.unsubscribe();
        }
        if (this.moreCategoryDealsSubscription) {
            this.moreCategoryDealsSubscription.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.getCategoryData();
        this.scrollablePane = document.getElementsByClassName('pane')[0];
    }

    redirectToProdDetail(id: number, productPath: string, name: string) {
        gtmDealClick(id, name, this.sectionName);
        this.categoryService.scrollPosition = this.scrollablePane.scrollTop;
        this.deviceCommsService.openLinkInNewTabIfBrowser(
            `/deal/${productPath}/${id}`
        );
    }

    getCategoryData() {
        this.paramsSubscription = this.activatedRoute.params.subscribe(
            (params) => {
                this.sectionId = Number(params['sectionId']);
                this.sectionName = params['sectionName'];
                this.routeParamsService.setSectionId(this.sectionId);
            }
        );
        this.subscription = combineLatest([
            this.activatedRoute.params,
            this.currencyLanguageService.getLocaleData(),
        ]).subscribe(([_, locale]) => {
            this.localeData = locale;

            this.categoryDealsSubscription = this.categoryService
                .getCategoryDetails(
                    [],
                    undefined,
                    locale.language,
                    this.sectionId,
                    locale.country
                )
                .subscribe({
                    next: (response: CategoryProducts) => {
                        this.categoryData = [...response.data];
                        this.totalRecords = response.total;

                        // if (this.categoryService.scrollPosition) {
                        //     setTimeout(() => {
                        //         this.scrollablePane.scrollTop =
                        //             this.categoryService.scrollPosition;
                        //     }, 0);
                        // }
                    },
                });
        });
    }

    onScroll() {
        if (this.categoryData.length < this.totalRecords) {
            this.loadingMoreDeals = true;
            this.currentPage += 1;

            this.moreCategoryDealsSubscription = this.categoryService
                .getMoreCategoryDetails(
                    this.currentPage,
                    [],
                    undefined,
                    this.localeData.language,
                    this.sectionId,
                    this.localeData.country
                )
                .subscribe({
                    next: (response: CategoryProducts) => {
                        this.categoryData = response.data;
                        this.loadingMoreDeals = false;
                        this.totalRecords = response.total;
                    },
                });
        }
    }
    // get all the items
    // get more on scroll
    // just always send empty filters and sorting
    // when clicking to go to the pdp, store the scroll position
}
